<div class="card card-p2p-detail mb-3">
    <div class="card-body card-body--p2p">
        <div class="d-flex">
            <div class="d-block">
                <div class="position-relative mb-4">
                    <img [src]="image" style="border-radius: 5px" alt="P2P Team Image" class="img-fluid rounded-start" style="width: 200px; min-height: 80px; border-radius: 4px;">
                </div>
            </div>
            <div class="d-flex flex-column w-100 ml-4 mr-3">
                <div class="d-flex align-items-center justify-content-between">
                    <h5 class="subtitle-1--weight-regular mb-0 pb-1">{{team.name}}</h5>
                </div>
                <div class="row mt-3">
                    <div class="col-5 d-flex w-100">
                        <div class="d-block w-100">
                            <div class="d-block progress md-progress p2p-detail-progress">        
                                <div 
                                    role="progressbar" [attr.aria-valuenow]="progressValue" aria-valuemin="0" aria-valuemax="100"
                                    class="progress-bar active" 
                                    [style]="progressNgStyle">
                                </div>                                
                                <div class="progress-value text-center p2p-detail-progress--text">{{raised | currency:'USD':'symbol-narrow':'1.0-0'}} of {{team.goal | currency:'USD':'symbol-narrow':'1.0-0'}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center body-2"> {{teamFundraisers.length}} Fundraiser(s) </div>
                </div>
                <div class="row mt-3 mb-n2">
                    <div class="col-5 mt-auto d-flex">
                        <div class="d-flex show pr-2" x-placement="bottom-end">                                
                            <app-p2p-link-popover [title]="'Donate Link'" [params] = "donateUrlParams"></app-p2p-link-popover>
                        </div>
                    </div>
                    <div class="mt-auto">
                        <span class="body-2 cursor--pointer" style="color: #0076FF;" (click)="viewTeamFundraisers()">View Fundraisers</span>
                    </div>

                    <div class="d-flex show ml-auto pr-2" x-placement="bottom-end">                                
                        <app-p2p-team-popover [fundraisers]="teamFundraisers" [teamName]="team.name"></app-p2p-team-popover>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>